export default {
  darkTextPrimary: "rgba(0, 0, 0, 0.87)",
  darkTextSecondary: "#79766d",
  lightPrimary: "#000000",
  darkPrimary: "#263040",
  lightSecondary: "#e4f5ff",
  darkBackgroundText: "#fff",
  lightBackgroundText: "#000",
  lightGray: "#e6e4dd",
  middleGray: "rgba(0,0,0,0.4)",
  darkGray: "#79766d",
};
